export default "__VITE_ASSET__C9JRjemO__"